import * as React from "react"
import { Head } from "@inertiajs/react"
import { Plus } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { ExamFormDialog } from "@/components/exams/ExamFormDialog"
import { ExamList } from "@/components/exams/ExamList"
import { Button } from "@/components/ui/button"
import type { ProgramOption } from "@/components/ProgramSelect"
import type { ExamSummary } from "@/types/exams"

export default function AdminPracticeExamsIndex({
  exams,
  exam_versions,
  programs,
}: {
  exams: ExamSummary[]
  exam_versions: { id: number; name: string }[]
  programs: ProgramOption[]
}) {
  const [creating, setCreating] = React.useState(false)
  const description = "Build, balance, and publish full-length NCMHCE practice exams for each exam version."

  return (
    <>
      <Head title="Practice exams">
        <meta name="description" content={description} />
        <meta property="og:title" content="Practice exams" />
        <meta property="og:description" content={description} />
      </Head>
      <AdminShell>
        <PageHeader
          title="Practice exams"
          description="Case-study exams for each exam version. Drafts stay hidden until you publish them."
          actions={
            <Button type="button" onClick={() => setCreating(true)}>
              <Plus className="h-4 w-4" /> New exam
            </Button>
          }
        />
        <div className="mt-6">
          {exams.length === 0 ? (
            <div className="callout">
              <p>No practice exams yet. Create one, then add case studies by hand or draft them with AI.</p>
            </div>
          ) : (
            <ExamList exams={exams} hrefFor={(exam) => `/admin/practice_exams/${exam.id}`} admin />
          )}
        </div>
        <ExamFormDialog
          open={creating}
          onOpenChange={setCreating}
          action="/admin/practice_exams"
          method="post"
          title="New practice exam"
          submitLabel="Create draft"
          examVersions={exam_versions}
          programs={programs}
        />
      </AdminShell>
    </>
  )
}
